
import setRealTimePriceLoading from "@dana/Store/Data/RealTimePriceLoading/Handlers/RealTimePriceLoadingHandler";
import {
    addToChainAfter, addToChainBefore
} from "@insite/client-framework/HandlerCreator";
import { chain, ExecuteOnErrorCallback, PopulateApiParameter } from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";



// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

// trying to reference a handler not in the chain will result in a warning and the chain will not be modified
addToChainBefore(
    chain,
    PopulateApiParameter,
    props => {     
        props.dispatch({
            type: "RealTimePrice/IsLoading",
            isLoading: true,
        } as any);
    },
);
addToChainAfter(
    chain,
    ExecuteOnErrorCallback,
    props => {
          props.dispatch({
            type: "RealTimePrice/IsLoading",
            isLoading: false,
        } as any);
    },
);
